<template>
    <el-dialog title="设置用户隐私协议" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" 
    :close-on-press-escape="false">
      <!--form表单-->
      <el-form size="small" ref="form" :model="form" :rules="formRules" :label-width="formLabelWidth">
        <el-form-item label="手机号" prop="contact_phone">
          <el-input v-model="form.contact_phone" placeholder="请输入手机号"></el-input></el-form-item>
    
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
  import PortApi from '@/api/port.js';
  export default {
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        /*是否显示*/
        dialogVisible: false,
        /*form表单对象*/
        form: {
          contact_phone:""
        },
        /*form验证*/
        formRules: {
          contact_phone: [
            {
              required: true,
              message: ' ',
              trigger: 'blur'
            }
          ],
        }
      };
    },
    props: ['setprivacy'],
    watch: {
      setprivacy: function(n, o) {
        if (n != o) {
          this.dialogVisible = this.setprivacy;
          this.port_id = this.$route.query.port_id;
          this.get(this.port_id)
        }
      }
    },
    created() {
   
    },
    methods: {
      /*添加*/
      onSubmit() {
        var form = this.form;
      console.log(form)

      let self = this;
      let Params = {};
      Params.port_id = self.port_id;
      Params.contact_phone = form.contact_phone
      PortApi.setPrivacy(Params, true)
        .then(res => {
          self.loading = false;
          console.log(res)
          if(res.msg == "success"){
              self.$message({
              message: res.data,
              type: 'success'
            });
            self.dialogFormVisible(true)
          }else{
            self.$message({
              message: res.data,
              type: 'success'
            });
          }
        
        })
        .catch(error => {self.loading = false;});
      },
  
      get(port_id) {
      var form = this.form;
      let self = this;
      let Params = {};
      Params.port_id = port_id;
      console.log(Params)
      PortApi.getPrivacy(Params, true)
        .then(res => {
          self.loading = false;
          self.form.contact_phone = res.data.owner_setting.contact_phone

          console.log(res)
        })
        .catch(error => {self.loading = false;});
    },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('close', {
            type: 'success',
            openDialog: false
          });
        } else {
          this.$emit('close', {
            type: 'error',
            openDialog: false
          });
        }
      }
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/port/manager/codemanager/dialog/setprivacy.vue